import type { GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import { ServicesPage } from '@/components/pages/ServicesPage';
import { ServicesPageSP } from '@/components/pages/ServicesPageSP';
import { Meta } from '@/layouts/Meta';
import { client } from '@/libs/client';
import { Main } from '@/templates/Main';

export type Service = {
  id: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  revisedAt: string;
  name: string;
  icon: {
    url: string;
  };
  icon_white: {
    url: string;
  };
  cover_title: string;
  cover_decription: string;
  cover_image: {
    url: string;
  };
  service_list_title: string;
  service_list_heading: string;
  serivce_contents: string;
};

const Index = ({ services }: { services: Service[] }) => {
  return (
    <Main
      meta={
        <Meta
          title="サービス紹介｜税理士法人奏共同会計事務所"
          description="税理士法人奏共同会計事務所は、資本戦略の実行支援を専門とする日本唯一の税理士法人です。組織再編、事業承継、M&A、国際資本戦略など、企業の成長ステージに応じた先進的なソリューションを提供。高い職業倫理と専門性を持つプロフェッショナル集団として、お客様の経営課題解決を支援します。"
        />
      }
      desktop={<ServicesPage services={services} />}
      mobile={<ServicesPageSP services={services} />}
    />
  );
};
export const getServerSideProps: GetServerSideProps<{
  services: Service[];
}> = async ({ locale }) => {
  const res = await client.getList<Service>({
    endpoint: 'services',
    queries: { limit: 10 },
  });

  return {
    props: {
      services: res.contents,
      ...(await serverSideTranslations(locale!, ['common', 'services'])),
    },
  };
};

export default Index;
